import { render, staticRenderFns } from "./InvoiceAnnexesModal.vue?vue&type=template&id=58c04c76"
import script from "./InvoiceAnnexesModal.vue?vue&type=script&lang=js"
export * from "./InvoiceAnnexesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports